import React from 'react';
import { Route } from 'react-router-dom';
import RouteEmployee from '../.././utility/common/RouteEmployee';
import RouteClaim from '../.././utility/common/RouteClaim';
import RouteAdmin from '../.././utility/common/RouteAdmin';
import RouteAgent from '../.././utility/common/RouteAgent';
//import RouteManager from '../.././utility/common/RouteManager';
import RouteTools from '../.././utility/common/RouteTools';
// import Signup from '../.././components/clients/signup/Signup';

const RefreshUser = React.lazy(() => import('../.././components/common/RefreshUser'));

const Login = React.lazy(() => import('../.././components/clients/login/Login'));
const Logout = React.lazy(() => import('../.././components/clients/login/Logout'));
const PasswordReset = React.lazy(() => import('../.././components/clients/login/PasswordReset'));
const PasswordResetSuccess = React.lazy(() => import('../.././components/clients/login/PasswordResetSuccess'));
const PasswordUpdate = React.lazy(() => import('../.././components/clients/login/PasswordUpdate'));
const PasswordUpdateSuccess = React.lazy(() => import('../.././components/clients/login/PasswordUpdateSuccess'));

const Dashboard = React.lazy(() => import('../.././components/clients/Dashboard'));
const Employee = React.lazy(() => import('../.././components/clients/myolympia/Employee'));
const EmployeePlanDetails = React.lazy(() => import('../.././components/clients/myolympia/EmployeePlanDetails'));
const ObiResources = React.lazy(() => import('../.././components/clients/myolympia/ObiResources'));
const HsaAgreement = React.lazy(() => import('../.././components/clients/myolympia/HsaAgreement'));
const UpdateNotes = React.lazy( () => import('../.././components/clients/myolympia/UpdateNotes'));
const EmployeeNotifications = React.lazy(() => import('../.././components/clients/myolympia/EmployeeNotifications'));

const DemoInfo = React.lazy(() => import('../.././components/clients/demo/DemoAccountInfo'));
const DemoLogin = React.lazy(() => import('../.././components/clients/demo/DemoLogin'));
const DemoClaims = React.lazy(() => import('../.././components/clients/demo/claims/DemoClaimDetails'));
const DemoClaimsReview = React.lazy(() => import('../.././components/clients/demo/claims/DemoClaimReview'));
const DemoClaimsSuccess = React.lazy(() => import('../.././components/clients/demo/claims/DemoClaimSuccess'));

const ObiSignup = React.lazy(() => import('../.././components/clients/obisignup/SignupForm'));
const ObiSignupReview = React.lazy(() => import('../.././components/clients/obisignup/SignupStripeReview'));
const ObiSignupThanks = React.lazy(() => import('../.././components/clients/obisignup/SignupFormThanks'));

const EmployeeClaimReport = React.lazy(() => import('../.././components/clients/myolympia/EmployeeClaimReport'));
const EmployeeClaimPrint = React.lazy(() => import('../.././components/clients/myolympia/EmployeeClaimPrint'));
const EmployeeBankingPAD = React.lazy(() => import('../.././components/clients/myolympia/EmployeeBankingPAD'));
const EmployeeSummaryOfBenefitsReport = React.lazy(() => import('../.././components/clients/myolympia/EmployeeSummaryOfBenefitsReport'));
const EmployeeBalanceReport = React.lazy(() => import('../.././components/clients/myolympia/EmployeeBalanceReport'));

const EmployeeClaimDetails = React.lazy(() => import('../.././components/clients/myolympia/EmployeeClaimDetails'));
const AuditForm = React.lazy(() => import('../.././components/clients/myolympia/AuditForm'));

const CompanyReports = React.lazy(() => import('../.././components/clients/myolympia/company/CompanyReports'));
const CompanyBalanceRefund = React.lazy(() => import('../.././components/clients/myolympia/company/CompanyBalanceRefund'));
const CompanyInsuranceFunding = React.lazy(() => import('../.././components/clients/myolympia/company/CompanyInsuranceFunding'));
const BusinessClassifications = React.lazy( () => import('../.././components/clients/myolympia/company/BusinessClassifications'));
const BusinessDivisions = React.lazy( () => import('../.././components/clients/myolympia/company/BusinessDivisions'));
const CompanyFunding = React.lazy( () => import('../.././components/clients/myolympia/company/CompanyFunding'));
const BusinessBankingPAD = React.lazy( () => import('../.././components/clients/myolympia/company/BusinessBankingPAD'));
const BusinessBankingStripe = React.lazy( () => import('../.././components/clients/myolympia/company/BusinessBankingStripe'));
const BusinessPlanDetails = React.lazy( () => import('../.././components/clients/myolympia/company/BusinessPlanDetails'));
const BusinessActivateOnlineClaims = React.lazy( () => import('../.././components/clients/myolympia/company/BusinessActivateOnlineClaims'));
const Employer = React.lazy(() => import('../.././components/clients/myolympia/company/Employer'));
const BusinessEmployees = React.lazy(() => import('../.././components/clients/myolympia/company/BusinessEmployees'));
const EmployerAddEE = React.lazy( () => import('../.././components/clients/myolympia/company/EmployerAddEE'));
const EmployerAddEESuccess = React.lazy( () => import('../.././components/clients/myolympia/company/EmployerAddEESuccess'));

const Claims = React.lazy( () => import('../.././components/clients/myolympia/claims/Claims'))
const WrapperResume = React.lazy( () => import('../.././components/clients/myolympia/claims/wrappers/Resume'))
const WrapperDetails = React.lazy( () => import('../.././components/clients/myolympia/claims/wrappers/Details'))
const WrapperUpload = React.lazy( () => import('../.././components/clients/myolympia/claims/wrappers/Upload'))
const WrapperReview = React.lazy( () => import('../.././components/clients/myolympia/claims/wrappers/Review'))
const WrapperSuccess = React.lazy( () => import('../.././components/clients/myolympia/claims/wrappers/Success'))
// const ClaimResume = React.lazy( () => import('../.././components/clients/myolympia/claims/hsa/ClaimResume'))
// const ClaimUpload = React.lazy( () => import('../.././components/clients/myolympia/claims/hsa/ClaimUpload'))
// const ClaimDetails = React.lazy( () => import('../.././components/clients/myolympia/claims/hsa/ClaimDetails'))
// const ClaimReview = React.lazy( () => import('../.././components/clients/myolympia/claims/hsa/ClaimReview'))
// const ClaimComplete = React.lazy( () => import('../.././components/clients/myolympia/claims/hsa/ClaimComplete'))

const WellnessSetup = React.lazy( () => import('../.././components/clients/myolympia/wellness/WellnessSetup'));
const WellnessManage = React.lazy( () => import('../.././components/clients/myolympia/wellness/WellnessManage'));
const WellnessSetupSuccess = React.lazy( () => import('../.././components/clients/myolympia/wellness/WellnessSetupSuccess'));

const PartnerLogin = React.lazy(() => import('../.././components/agents/login/Login'));
const PartnerPasswordReset = React.lazy(() => import('../.././components/agents/login/PasswordReset'));
const PartnerPasswordResetSuccess = React.lazy(() => import('../.././components/agents/login/PasswordResetSuccess'));
const PartnerPasswordUpdate = React.lazy(() => import('../.././components/agents/login/PasswordUpdate'));
const PartnerPasswordUpdateSuccess = React.lazy(() => import('../.././components/agents/login/PasswordUpdateSuccess'));
const PartnerSignup = React.lazy(() => import('../.././components/agents/signup/Signup'));
const PartnerSignupReview = React.lazy(() => import('../.././components/agents/signup/SignupReview'));
const PartnerSignupThanks = React.lazy(() => import('../.././components/agents/signup/SignupThankyou'));
const PartnerDashboard = React.lazy(() => import('../.././components/agents/Dashboard'));
const PartnerInfo = React.lazy(() => import('../.././components/agents/myolympia/PartnerInfo'));
const PartnerLogout = React.lazy(() => import('../.././components/agents/login/Logout'));
const PartnerHelp = React.lazy(() => import('../.././components/agents/myolympia/PartnerHelp'));
const PartnerForms = React.lazy(() => import('../.././components/agents/myolympia/PartnerForms'));
const PartnerClientList = React.lazy( () => import('../.././components/agents/myolympia/PartnerClientList'));
const PartnerAgentList = React.lazy( () => import('../.././components/agents/myolympia/PartnerAgentList'));
const PartnerCommissions = React.lazy( () => import('../.././components/agents/myolympia/PartnerCommissions'));
const PartnerHSASales = React.lazy( () => import('../.././components/agents/myolympia/PartnerHSASales'));
const PartnerUpcomingRenewals = React.lazy( () => import('../../components/agents/myolympia/PartnerUpcomingRenewals'));
const PartnerClientDetails = React.lazy( () => import('../.././components/agents/myolympia/PartnerClientDetails'));
const PartnerBanking = React.lazy( () => import('../.././components/agents/myolympia/PartnerBanking'));
const PartnerPersonal = React.lazy( () => import('../.././components/agents/myolympia/Partner'));
const PartnerNotifications = React.lazy( () => import('../.././components/agents/myolympia/PartnerNotifications'));
const PartnerUpdateNotes = React.lazy( () => import('../.././components/agents/myolympia/PartnerUpdateNotes'));

const ToolsLogin = React.lazy(() => import('../.././components/tools/login/Login'));
const ToolsDashboard = React.lazy(() => import('../.././components/tools/Dashboard'));
const ManageAds = React.lazy(() =>import('../.././components/tools/myolympia/ManageAds'));
const ModifyAd = React.lazy(() =>import('../.././components/tools/myolympia/ModifyAd'));
const ManageUpdateNotes = React.lazy(() =>import('../.././components/tools/myolympia/ManageUpdateNotes'));
const ModifyUpdateNote = React.lazy(() =>import('../.././components/tools/myolympia/ModifyUpdateNote'));
const ToolsAccessUser = React.lazy(() => import('../../components/tools/myolympia/LoginAccount'));
const HSAReceiptEmail = React.lazy(() => import('../../components/tools/myolympia/HSAReceiptEmail'));
const WelcomeResendEmail = React.lazy(() => import('../../components/tools/myolympia/WelcomeResendEmail'));
const PartnerReceiptEmail = React.lazy(() => import('../../components/tools/myolympia/PartnerReceiptEmail'));
const TransferDetails = React.lazy(() => import('../../components/tools/myolympia/TransferDetails'));
const ApiRoutes = React.lazy(() => import('../../components/tools/myolympia/ApiRoutes'));
const ApiTester = React.lazy(() => import('../../components/tools/myolympia/ApiTester'));
const ClaimAudit = React.lazy(()=> import('../../components/tools/myolympia/ClaimAudit'));
const PADAuditAgent = React.lazy(()=> import('../../components/tools/myolympia/PADAuditAgent'));
const PADDetailsAuditAgent = React.lazy(()=> import('../../components/tools/myolympia/PADDetailsAuditAgent'));
const PADAuditEmployee = React.lazy(()=> import('../../components/tools/myolympia/PADAuditEmployee'));
const PADDetailsAuditEmployee = React.lazy(()=> import('../../components/tools/myolympia/PADDetailsAuditEmployee'));
const PADAuditEmployer = React.lazy(()=> import('../../components/tools/myolympia/PADAuditEmployer'));
const PADDetailsAuditEmployer = React.lazy(()=> import('../../components/tools/myolympia/PADDetailsAuditEmployer'));
const ClaimDetailsAudit = React.lazy(()=> import('../../components/tools/myolympia/ClaimDetailsAudit'));
const ToolsSales = React.lazy(() => import('../../components/tools/myolympia/Sales'));
const RecalculateEmployeeLimit = React.lazy(() => import('../../components/tools/myolympia/RecalculateEmployeeLimit'));
const ToolsLogout = React.lazy(() => import('../.././components/tools/login/Logout'));

export const publicRoutes = [
  {
    path: "/refresh",
    exact: true,
    componentName: 'RefreshUser',
    component: RefreshUser,
    type: Route
  },
  {
    path: "/demo",
    exact: true,
    componentName: 'DemoLogin',
    component: DemoLogin,
    type: Route
  },
  {
     path: "/demo/personal",
     exact: true,
     componentName: 'DemoInfo',
     component: DemoInfo,
     type: Route
  },
  {
     path: "/demo/claims",
     exact: true,
     componentName: 'DemoClaims',
     component: DemoClaims,
     type: Route
  },
  {
    path: "/demo/claims/review",
    exact: true,
    componentName: 'DemoClaimsReview',
    component: DemoClaimsReview,
    type: Route
  },
  {
    path: "/demo/claims/success",
    exact: true,
    componentName: 'DemoClaimsSuccess',
    component: DemoClaimsSuccess,
    type: Route
  },
  {
    path: "/signup",
    exact: true,
    componentName: 'Signup',
    component: ObiSignup,
    type: Route
  },
  {
    path: "/signup/:id",
    exact: true,
    componentName: 'Signup',
    component: ObiSignup,
    type: Route
  },
  {
    path: "/signup/review/:id",
    exact: true,
    componentName: 'Signup',
    component: ObiSignupReview,
    type: Route
  },
  {
    path: "/signup/thanks/:id",
    exact: true,
    componentName: 'Signup Thanks',
    component: ObiSignupThanks,
    type: Route
  },
  {
    path: "/login",
    exact: true,
    componentName: 'Login',
    component: Login,
    type: Route
  },
  {
    path: "/login/reset",
    exact: true,
    componentName: 'PasswordReset',
    component: PasswordReset,
    type: Route
  },
  {
    path: "/login/reset/success",
    exact: true,
    componentName: 'PasswordResetSuccess',
    component: PasswordResetSuccess,
    type: Route
  },
  {
    path: "/login/update/success",
    exact: true,
    componentName: 'PasswordUpdateSuccess',
    component: PasswordUpdateSuccess,
    type: Route
  },
  {
    path: "/login/update/:id",
    exact: true,
    componentName: 'PasswordUpdate',
    component: PasswordUpdate,
    type: Route
  },
  {
    path: "/partner/signup",
    exact: true,
    componentName: 'PartnerSignup',
    component: PartnerSignup,
    type: Route
  },
  {
    path: "/partner/signup/review",
    exact: true,
    componentName: 'PartnerSignup',
    component: PartnerSignupReview,
    type: Route
  },
  {
    path: "/partner/signup/thanks",
    exact: true,
    componentName: 'PartnerSignup',
    component: PartnerSignupThanks,
    type: Route
  },
  {
    path: "/partner/login",
    exact: true,
    componentName: 'PartnerLogin',
    component: PartnerLogin,
    type: Route
  },
  {
    path: "/partner/login/reset",
    exact: true,
    componentName: 'PartnerPasswordReset',
    component: PartnerPasswordReset,
    type: Route
  },
  {
    path: "/partner/login/reset/success",
    exact: true,
    componentName: 'PartnerPasswordResetSuccess',
    component: PartnerPasswordResetSuccess,
    type: Route
  },
  {
    path: "/partner/login/update/success",
    exact: true,
    componentName: 'PartnerPasswordUpdateSuccess',
    component: PartnerPasswordUpdateSuccess,
    type: Route
  },
  {
    path: "/partner/login/update/:id",
    exact: true,
    componentName: 'PartnerPasswordUpdate',
    component: PartnerPasswordUpdate,
    type: Route
  },
  {
    path: "/logout",
    exact: true,
    componentName: 'Logout',
    component: Logout,
    type: Route
  },
  {
    path: "/partner/logout",
    exact: true,
    componentName: 'Logout',
    component: PartnerLogout,
    type: Route
  },
  {
    path: "/tools/login",
    exact: true,
    componentName: 'Login',
    component: ToolsLogin,
    type: Route
  },
  {
    path: "/tools/logout",
    exact: true,
    componentName: 'Logout',
    component: ToolsLogout,
    type: Route
  },
  {
    path: "/tools/sales",
    exact: true,
    componentName: 'ToolsSales',
    component: ToolsSales,
    type: Route
  },
];

export const employeeRoutes = [
  {
    path: "/employee/:id",
    exact: true,
    componentName: 'Employee',
    component: Employee,
    type: RouteEmployee
  },
  {
    path: "/employee",
    exact: true,
    componentName: 'Employee',
    component: Employee,
    type: RouteEmployee
  },
  {
    path: "/update-notes",
    exact: true,
    componentName: 'UpdateNotes',
    component: UpdateNotes,
    type: RouteEmployee
  },
  {
    path: "/my-plan",
    exact: true,
    componentName: 'EmployeePlanDetails',
    component: EmployeePlanDetails,
    type: RouteEmployee
  },
  {
    path: '/banking-details',
    exact: true,
    componentName:'EmployeeBankingDetails',
    component: EmployeeBankingPAD,
    type: RouteEmployee
  },
  {
    path: "/hsa-agreement",
    exact: true,
    componentName: 'HsaAgreement',
    component: HsaAgreement,
    type: RouteEmployee
  },
  {
    path: "/claim-report",
    exact: true,
    componentName: 'EmployeeClaimReport',
    component: EmployeeClaimReport,
    type: RouteEmployee
  },
  {
    path: '/balance-report',
    exact: true,
    componentName: 'EmployeeBalanceReport',
    component: EmployeeBalanceReport,
    type: RouteEmployee
  },
  {
    path: "/summary-of-benefits",
    exact: true,
    componentName: 'EmployeeSummaryOfBenefitsReport',
    component: EmployeeSummaryOfBenefitsReport,
    type: RouteEmployee
  },
  {
    path: "/documents",
    exact: true,
    componentName: 'ObiResources',
    component: ObiResources,
    type: RouteEmployee
  },
  {
    path: "/claim/:id",
    exact: true,
    componentName: 'EmployeeClaimDetails',
    component: EmployeeClaimDetails,
    type: RouteEmployee
  },
  {
    path: "/audit/:id",
    exact: true,
    componentName: 'AuditForm',
    component: AuditForm,
    type: RouteEmployee
  },
  {
    path: "/notifications",
    exact: true,
    componentName: 'EmployeeNotifications',
    component: EmployeeNotifications,
    type: RouteEmployee
  },
  {
    path: "/",
    exact: true,
    componentName: 'Dashboard',
    component: Dashboard,
    type: RouteEmployee
  },
  {
    path: "/claim-form-print",
    exact: true,
    componentName: 'EmployeeClaimPrint',
    component: EmployeeClaimPrint,
    type: RouteEmployee
  },
  {
    path: "/claim-form-print/:id",
    exact: true,
    componentName: 'EmployeeClaimPrint',
    component: EmployeeClaimPrint,
    type: RouteEmployee
  },
];

export const adminRoutes = [
  {
    path: "/add-employee",
    exact: true,
    componentName: 'BusinessAddEmployees',
    component: EmployerAddEE,
    type: RouteAdmin
  },
  {
    path: "/add-employee/success",
    exact: true,
    componentName: 'BusinessAddEmployeesSuccess',
    component: EmployerAddEESuccess,
    type: RouteAdmin
  },
  {
    path: "/divisions",
    exact: true,
    componentName: 'BusinessDivisions',
    component: BusinessDivisions,
    type: RouteAdmin
  },
  {
    path: "/business-plan",
    exact: true,
    componentName: 'BusinessPlanDetails',
    component: BusinessPlanDetails,
    type: RouteAdmin
  },
  {
    path: "/business-banking",
    exact: true,
    componentName: 'BusinessBankingPAD',
    component: BusinessBankingPAD,
    type: RouteAdmin
  },
  {
    path: "/wellness/setup",
    exact: true,
    componentName: 'WellnessSetup',
    component: WellnessSetup,
    type: RouteAdmin
  },
  {
    path: "/wellness/setup/success",
    exact: true,
    componentName: 'WellnessSetupSuccess',
    component: WellnessSetupSuccess,
    type: RouteAdmin
  },
  {
    path: "/wellness/manage",
    exact: true,
    componentName: 'WellnessManage',
    component: WellnessManage,
    type: RouteAdmin
  },
  {
    path: "/company-funding",
    exact: true,
    componentName: 'CompanyFunding',
    component: CompanyFunding,
    type: RouteAdmin
  },
  {
    path: "/insurance-funding",
    exact: true,
    componentName: 'CompanyInsuranceFunding',
    component: CompanyInsuranceFunding,
    type: RouteAdmin
  },
  {
    path: "/business-online-claims",
    exact: true,
    componentName: 'BusinessActivateOnlineClaims',
    component: BusinessActivateOnlineClaims,
    type: RouteAdmin
  },
  {
    path: "/update-card",
    exact: true,
    componentName: 'BusinessUpdateCard',
    component: BusinessBankingStripe,
    type: RouteAdmin
  },
  {
    path: "/company-reports",
    exact: true,
    componentName: 'CompanyReports',
    component: CompanyReports,
    type: RouteAdmin
  },
  {
    path: "/company-reports/:report",
    exact: true,
    componentName: 'CompanyReports',
    component: CompanyReports,
    type: RouteAdmin
  },
  {
    path: "/classifications",
    exact: true,
    componentName: 'BusinessClassifications',
    component: BusinessClassifications,
    type: RouteAdmin
  },
  {
    path: "/employer",
    exact: true,
    componentName: 'Employer',
    component: Employer,
    type: RouteAdmin
  },
  {
    path: "/directory/employees",
    exact: true,
    componentName: 'BusinessEmployees',
    component: BusinessEmployees,
    type: RouteAdmin
  },
];

export const agentRoutes = [
  {
    path: "/partner/agent/:id",
    exact: true,
    componentName: 'Partner',
    component: PartnerInfo,
    type: RouteAgent
  },
  {
    path: "/partner",
    exact: true,
    componentName: 'PartnerDashboard',
    component: PartnerDashboard,
    type: RouteAgent
  },
  {
    path: "/partner/notifications",
    exact: true,
    componentName: 'PartnerNotifications',
    component: PartnerNotifications,
    type: RouteAgent
  },
  {
    path: "/partner/banking",
    exact: true,
    componentName: 'Banking Information',
    component: PartnerBanking,
    type: RouteAgent
  },
  {
    path: "/partner/personal",
    exact: true,
    componentName: 'Personal Information',
    component: PartnerPersonal,
    type: RouteAgent
  },
  {
    path: "/partner/marketing-tools",
    exact: true,
    componentName: 'PartnerForms',
    component: PartnerForms,
    type: RouteAgent
  },
  {
    path: "/partner/documents",
    exact: true,
    componentName: 'PartnerForms',
    component: PartnerForms,
    type: RouteAgent
  },
  {
    path: "/partner/faqs",
    exact: true,
    componentName: 'PartnerHelp',
    component: PartnerHelp,
    type: RouteAgent
  },
  {
    path: "/partner/client-list",
    exact: true,
    componentName: 'PartnerClientList',
    component: PartnerClientList,
    type: RouteAgent
  },
  {
    path: "/partner/client-list/:id",
    exact: true,
    componentName: 'PartnerClientList',
    component: PartnerClientList,
    type: RouteAgent
  },
  {
    path: "/partner/agent-list",
    exact: true,
    componentName: 'PartnerAgentList',
    component: PartnerAgentList,
    type: RouteAgent
  },
  {
    path: "/partner/commissions",
    exact: true,
    componentName: 'PartnerCommissions',
    component: PartnerCommissions,
    type: RouteAgent
  },
  {
    path: "/partner/commissions/:id",
    exact: true,
    componentName: 'PartnerCommissions',
    component: PartnerCommissions,
    type: RouteAgent
  },
  {
    path: "/partner/hsa-sales",
    exact: true,
    componentName: 'PartnerHSASales',
    component: PartnerHSASales,
    type: RouteAgent
  },
  {
    path: "/partner/upcoming-renewals",
    exact: true,
    componentName: 'PartnerUpcomingRenewals',
    component: PartnerUpcomingRenewals,
    type: RouteAgent
  },
  {
    path: "/partner/update-notes",
    exact: true,
    componentName: 'PartnerUpdateNotes',
    component: PartnerUpdateNotes,
    type: RouteAgent
  },
  {
    path: "/partner/employer/:id",
    exact: true,
    componentName: 'PartnerClientDetails',
    component: PartnerClientDetails,
    type: RouteAgent
  },
];

export const managerRoutes = [

];

export const claimRoutes = [
  {
    path: "/claims",
    exact: true,
    componentName: 'Claims',
    component: Claims,
    type: RouteClaim
  },
  {
    path: "/claims/resume",
    exact: true,
    componentName: 'WrapperResume',
    component: WrapperResume,
    type: RouteClaim
  },
  {
    path: "/claims/details",
    exact: true,
    componentName: 'WrapperDetails',
    component: WrapperDetails,
    type: RouteClaim
  },
  {
    path: "/claims/upload",
    exact: true,
    componentName: 'WrapperUpload',
    component: WrapperUpload,
    type: RouteClaim
  },
  {
    path: "/claims/review",
    exact: true,
    componentName: 'WrapperReview',
    component: WrapperReview,
    type: RouteClaim
  },
  {
    path: "/claims/success",
    exact: true,
    componentName: 'WrapperSuccess',
    component: WrapperSuccess,
    type: RouteClaim
  }
  // {
  //   path: "/claim/complete",
  //   exact: true,
  //   componentName: 'ClaimComplete',
  //   component: ClaimComplete,
  //   type: RouteClaim
  // },
];

export const toolsRoutes = [
  {
    path: "/tools/",
    exact: true,
    componentName: 'ToolsDashboard',
    component: ToolsDashboard,
    type: RouteTools
  },
  {
    path: "/tools/ads",
    exact: true,
    componentName: 'ManageAds',
    component: ManageAds,
    type: RouteTools
  },
  {
    path: "/tools/ad/:id",
    exact: true,
    componentName: 'ModifyAd',
    component: ModifyAd,
    type: RouteTools
  },
  {
    path: "/tools/updates",
    exact: true,
    componentName: 'ManageUpdateNotes',
    component: ManageUpdateNotes,
    type: RouteTools
  },
  {
    path: "/tools/update/:id",
    exact: true,
    componentName: 'ModifyUpdateNote',
    component: ModifyUpdateNote,
    type: RouteTools
  },
  {
    path: "/tools/login-account",
    exact: true,
    componentName: 'ToolsAccessUser',
    component: ToolsAccessUser,
    type: RouteTools
  },
  {
    path: "/tools/send-welcome/:type",
    exact: true,
    componentName: 'WelcomeResendEmail',
    component: WelcomeResendEmail,
    type: RouteTools
  },
  {
    path: "/tools/send-receipt",
    exact: true,
    componentName: 'HSAReceiptEmail',
    component: HSAReceiptEmail,
    type: RouteTools
  },
  {
    path: "/tools/send-partner-receipt",
    exact: true,
    componentName: 'PartnerReceiptEmail',
    component: PartnerReceiptEmail,
    type: RouteTools
  },
  {
    path: "/tools/api-routes",
    exact: true,
    componentName: 'ApiRoutes',
    component: ApiRoutes,
    type: RouteTools
  },
  {
    path: "/tools/api-tester",
    exact: true,
    componentName: 'ApiTester',
    component: ApiTester,
    type: RouteTools
  },
  {
    path: "/tools/pad-audit/agent",
    exact: true,
    componentName: 'PADAuditAgent',
    component: PADAuditAgent,
    type: RouteTools
  },
  {
    path: "/tools/pad-audit-details/agent/:id",
    exact: true,
    componentName: 'PADDetailsAuditAgent',
    component: PADDetailsAuditAgent,
    type: RouteTools
  },
  {
    path: "/tools/pad-audit/employee",
    exact: true,
    componentName: 'PADAuditEmployee',
    component: PADAuditEmployee,
    type: RouteTools
  },
  {
    path: "/tools/pad-audit-details/employee/:id",
    exact: true,
    componentName: 'PADDetailsAuditEmployee',
    component: PADDetailsAuditEmployee,
    type: RouteTools
  },
  {
    path: "/tools/pad-audit/employer",
    exact: true,
    componentName: 'PADAuditEmployer',
    component: PADAuditEmployer,
    type: RouteTools
  },
  {
    path: "/tools/pad-audit-details/employer/:id",
    exact: true,
    componentName: 'PADDetailsAuditEmployer',
    component: PADDetailsAuditEmployer,
    type: RouteTools
  },
  {
    path: "/tools/audit/claims",
    exact: true,
    componentName: 'ClaimAudit',
    component: ClaimAudit,
    type: RouteTools
  },
  {
    path: "/tools/audit/claim/:id",
    exact: true,
    componentName: 'ClaimDetailsAudit',
    component: ClaimDetailsAudit,
    type: RouteTools
  },
  {
    path: "/tools/transfer-details",
    exact: true,
    componentName: 'TransferDetails',
    component: TransferDetails,
    type: RouteTools
  },
  {
    path: "/tools/recal-employee-limit",
    exact: true,
    componentName: 'RecalculateEmployeeLimit',
    component: RecalculateEmployeeLimit,
    type: RouteTools
  },
];

export const bankingRequiredRoutes = [
  '/add-employee',
  '/company-funding',
  '/insurance-funding',
  '/wellness/setup',
  '/wellness/manage',
];

export const noRefUrls = [
  '/mylogin',
  '/logout',
  '/refresh',
  '/partner/mylogin',
  '/partner/logout',
  '/refresh'
];

export const familyRestrictedRoutes = [
  '/add-employee',
  '/classifications'
];

export const nonMemberRestrictedRoutes = [
  '/my-plan',
  '/banking-details',
  '/balance-report',
  '/claim-report',
  '/claim-form-print',
  '/claims'
];

export const terminatedAllowedRoutes = [
  '/',
  '/logout',
  '/balance-report',
  '/claim-report',
  '/company-reports',
  '/claim',
  '/business-plan'
];

export const terminatedInClaimPeriodAllowedRoutes = [
  '/',
  '/logout',
  '/balance-report',
  '/claim-report',
  '/company-reports',
  '/claim',
  '/claim-form-print',
  '/business-plan'
]
